<page-loader>
  <div class="mat-dialog-header">
    <div mat-dialog-title>
      Change Password
    </div>
  </div>
  <div mat-dialog-content>
    <p>
      We'll send a password reset link to <strong>{{ email }}</strong>. Click the link in that
      email to set a new password.
    </p>
  </div>
  <div mat-dialog-actions class="justify-content-end">
    <button mat-flat-button class="mr-3" [mat-dialog-close]="false">
      Cancel
    </button>
    <button mat-flat-button color="primary" [disabled]="!email" (click)="sendResetLink()">
      Send reset link
    </button>
  </div>
</page-loader>
